import "./AiToolsNavigationLink.scss";

import { View } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { IconChevronRightSmall } from "@amzn/stencil-react-icons";
import { trackCustomEvent } from "@amzn/uxm-stencil-react-components/lib/src/uxm/custom-event";
import { Paths } from "common/paths/paths";
import { config } from "config";
import React, { FC } from "react";

export interface AiToolsNavigationLinkProps {
  className?: string;
}

export const AiToolsNavigationLink: FC<AiToolsNavigationLinkProps> = ({ className }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    // Track analytics
    const trackerId = config.analytics.uxmAppId;
    const payload = {
      action: "navigate_to_aiforme",
      source: "search_filter_panel_category_link",
    };
    trackCustomEvent(payload, "aiforme-navigation-link", trackerId);
  };

  return (
    <View padding={["S200", "0"]} className={className}>
      <Link
        href={Paths.aiforme.url}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="AI tools — browse the AI-only catalog on AI for Me"
        data-testid="ai-tools-navigation-link"
        className="ai-tools-navigation-link"
      >
        <div className="ai-tools-navigation-link__content">
          <div className="ai-tools-navigation-link__title">AI tools</div>
          <div className="ai-tools-navigation-link__description">Browse our AI-only catalog on AI for Me</div>
        </div>
        <IconChevronRightSmall className="ai-tools-navigation-link__icon" />
      </Link>
    </View>
  );
};
